import styled, { css } from "styled-components";

export const PaginationWrapper = styled.div``;

export const PaginationContainer = styled.div`
  display: flex;
  gap: 4px;
  min-height: 44px;
  width: 100%;
`;

export const PageNumber = styled.button<{
  $selected?: boolean;
  $disabled?: boolean;
}>`
  height: 100%;
  min-height: 44px;
  min-width: 44px;
  width: max-content;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.default[400]};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  transition: 0.2s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $selected, theme }) =>
    $selected &&
    css`
      color: ${({ theme }) => theme.colors.default[900]};
      background: ${({ theme }) => theme.colors.default[100]};
    `}
  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.3;
      pointer-events: none;
    `}
    &:hover {
    color: ${({ theme }) => theme.colors.default[900]};
  }
`;
